module.exports = __webpack_public_path__ + "static/media/ic-add_attachment.da84d838.svg";